import { render } from "./UserAccountDropdown.vue?vue&type=template&id=4d85a82e&scoped=true"
import script from "./UserAccountDropdown.vue?vue&type=script&lang=js"
export * from "./UserAccountDropdown.vue?vue&type=script&lang=js"

import "./UserAccountDropdown.vue?vue&type=style&index=0&id=4d85a82e&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d85a82e"]])

export default __exports__